import React from "react";
import { Select, DatePicker,Layout } from "antd";
import Selection from "./Selection";
import WelcomeText from "../text/WelcomeText";

const Home = (props) =>{
	const { optionProps, selectSessionIndex } = props;
	const { RangePicker } = DatePicker;
	return <div>
		<WelcomeText />
		<div>
			<Selection defaultValue={optionProps[selectSessionIndex].value} style={{ width: 180 }} 
				onChange={props.onFilterChanged} 
				optionProps={optionProps}
			/>
        &nbsp;
			<RangePicker onChange={props.onDateChanged} />
		</div>
	</div>;
};

export default Home;


// WEBPACK FOOTER //
// ./src/components/form/SessionData.js